//import FacturacionClient from "./FacturacionClient.js";
import axiosClient from '../config/axios.js';


//////////////////////////////Clave de Producto//////////////////////////////////////////////////////
const prefix = "/sat";
// Buscar clave de producto
export async function findProductKeyByCoincidence(word) {
  return (await axiosClient.get(`${prefix}/product-keys/search/${word}`)).data;
}

// Tabla de claves de producto de un customer
export async function findMyProductKeyFavsDatatable({ start = 0, length = 10, search = '', sort = 'id', dir = 'asc' }) {
  const params = new URLSearchParams({
    start: start.toString(),
    length: length.toString(),
    search,
    sort,
    dir,
  });

  const response = await axiosClient.get(`/setting/product-key-favs/my/datatable?${params}`);
  return response.data;
}

// Asociar una clave de producto como favorita a un customer
export async function createProductKeyFav(idProductKey) {
  const response = await axiosClient.post(`/setting/product-key-favs`, {
    idProductKey, 
  });
  return response.data;
}

// Eliminar una clave de producto favorita de un customer
export async function deleteProductKeyFav(idProductKeyFav) {
  const response = await axiosClient.delete(`/setting/product-key-favs/${idProductKeyFav}`);
  return response.data;
}

// Busca claves de producto favoritas
export async function searchProductKeyFavs(term = "") {
  return (
    await axiosClient.get(`/setting/product-key-favs/search`, {
      params: { term },
    })
  ).data;
}


//////////////////////////////Clave de Unidad/////////////////////////////////////////////////

 export async function findUnitKeyByCoincidence(word) {
   return (await axiosClient.get(`${prefix}/unit-keys/search/${word}`)).data;
 }

 // Tabla de claves de unidad de un customer
export async function findMyUnitKeyFavsDatatable({ start = 0, length = 10, search = '', sort = 'id', dir = 'asc' }) {
  const params = new URLSearchParams({
    start: start.toString(),
    length: length.toString(),
    search,
    sort,
    dir,
  });
  const response = await axiosClient.get(`/setting/unit-key-favs/my/datatable?${params}`);
  return response.data;
}

// Asociar una clave de unidad como favorita a un customer
export async function createUnitKeyFav(idUnitKey) {
  const response = await axiosClient.post(`/setting/unit-key-favs`, {
    idUnitKey, 
  });
  return response.data;
}

// Eliminar una clave de unidad favorita de un customer
export async function deleteUnitKeyFav(idUnitKeyFav) {
  const response = await axiosClient.delete(`/setting/unit-key-favs/${idUnitKeyFav}`);
  return response.data;
}

// Busca claves de unidad favoritas
export async function searchUnitKeyFavs(term = "") {
  return (
    await axiosClient.get(`/setting/unit-key-favs/search`, {
      params: { term },
    })
  ).data;
}

//////////////////////////////Folios/////////////////////////////////////////////////

export async function createFolioContado(data, razonSocial) {
  const response = await axiosClient.post(`/setting/folio-contado/save/${razonSocial}`, data);
  return response.data;
}

export async function createFolioCredito(data, razonSocial) {
  const response = await axiosClient.post(`/setting/folio-credito/save/${razonSocial}`, data);
  return response.data;
}

export async function getFoliosBySocialReason(razonSocial) {
  const response = await axiosClient.get(`/setting/folios/${razonSocial}`);
  return response.data;
}

//////////////////////////////Series/////////////////////////////////////////////////

export async function createSerieContado(data, razonSocial) {
  const response = await axiosClient.post(`/setting/serie-contado/save/${razonSocial}`, data);
  return response.data;
}

export async function createSerieCredito(data, razonSocial) {
  const response = await axiosClient.post(`/setting/serie-credito/save/${razonSocial}`, data);
  return response.data;
}

export async function getSeriesBySocialReason(razonSocial) {
  const response = await axiosClient.get(`/setting/series/${razonSocial}`);
  return response.data;
}


//////////////////////////////CustomerSocialReason/////////////////////////////////

export async function getCustomerSocialReasonDatatable({
  draw = 1,
  start = 0,
  length = 10,
  search = '',
  sort = 'rfc',
  dir = 'asc',
  razonSocial
}) {
  const response = await axiosClient.get(`/customer-social-reason/datatable/${razonSocial}`, {
    params: {
      draw,
      start,
      length,
      search,
      sort,
      dir,
    },
  });

  return response.data;
}

export async function createCustomerSocialReason(data, razonSocial) {
  const response = await axiosClient.post(`/customer-social-reason/${razonSocial}`, data);
  return response.data;
}

export async function deleteCustomerSocialReason(idCustomerSocialReason, razonSocial) {
  const response = await axiosClient.delete(`/customer-social-reason/${idCustomerSocialReason}/${razonSocial}`);
  return response.data;
}

export async function getOneCustomerSocialReason(idCustomerSocialReason, razonSocial) {
  const response = await axiosClient.get(`/customer-social-reason/${idCustomerSocialReason}/${razonSocial}`);
  return response.data;
}

export async function updateCustomerSocialReason(idCustomerSocialReason, razonSocial, data) {
  const response = await axiosClient.put(`/customer-social-reason/${idCustomerSocialReason}/${razonSocial}`, data);
  return response.data;
}

export async function findCustomerSocialReasonByCoincidence(razonSocial, word) {
  return (await axiosClient.get(`/customer-social-reason/search/${razonSocial}/${word}`)).data;
}

//////////////////////////////Regimen fiscal/////////////////////////////////

// Obtener la lista de regímenes fiscales
export async function findFiscalRegimes() {
  const response = await axiosClient.get(`${prefix}/fiscal-regimes`);
  return response.data.map((regimen) => ({
    value: regimen.id,
    label: regimen.description,
  }));
}

export async function findFiscalRegimesByCoincidence(word) {
  return (await axiosClient.get(`${prefix}/fiscal-regimes/search/${word}`)).data;
}

//////////////////////////////CFDI/////////////////////////////////
export async function findCFDIByCoincidence(word) {
  return (await axiosClient.get(`${prefix}/cfdi/search/${word}`)).data;
}


///////////// Razón social ///////////////////////////////////////////////////////////////

export async function updateocialReason({
  id,
  rfc,
  name,
  description,
  fiscalRegimeId,
  logoId,
  razonSocial,
  postalCode,
  primaryColor
}) {
    const response = await axiosClient.put(
    `/social-reason/${razonSocial}`,
  {
    rfc,
    name,
    description,
    fiscalRegimeId,
    logoId,
    postalCode,
    primaryColor
  });
  return response.data;
}


export async function getMySocialReasons(razonSocial) {
  const response = await axiosClient.get(`/social-reason/byToken/${razonSocial}`);
  return response.data;
}



///////////upload files/////////////////////
export async function uploadFileToCatalog(file) {
  const formData = new FormData();
  formData.append("file", file); 
  try {
    const response = await axiosClient.post("/files/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al subir archivo:", error?.response?.data || error);
    throw error;
  }
}

export async function deleteFileById(id) {
  try {
    const response = await axiosClient.delete(`/files/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error al eliminar archivo:", error?.response?.data || error);
    throw error;
  }
}

export async function getFileLogo(fileId) {
  const response = await axiosClient.get(`/files/${fileId}`);
return response.data;
}

///////////CERTIFICADOS/////////////////////
export async function uploadCer({ cer, key, csdPassword, razonSocial }) {
  const formData = new FormData();
  formData.append("cer", cer); // archivo .cer
  formData.append("key", key); // archivo .key
  formData.append("csdPassword", csdPassword); // texto

  try {
    const response = await axiosClient.post(`/social-reason/upload-csd/${razonSocial}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al subir certificados:", error?.response?.data || error);
    throw error;
  }
}

//////////////////////////////Payment/////////////////////////////////
export async function findPaymentFormByCoincidence(word) {
  return (await axiosClient.get(`${prefix}/payment-form/search/${word}`)).data;
}

export async function findPaymentMethodByCoincidence(word) {
  return (await axiosClient.get(`${prefix}/payment-method/search/${word}`)).data;
}

//////////////////////////////Stamp/////////////////////////////////
export async function createStamp(data, razonSocial) {
  const response = await axiosClient.post(`/stamp/${razonSocial}`, data);
  return response.data;
}

export async function getStampFile(uuidStamp, razonSocial) {
  const response = await axiosClient.get(`/stamp/findFileById-zip/${uuidStamp}/${razonSocial}`);
  return response.data;
}

export async function generateInvoice(data, razonSocial) {
  const response = await axiosClient.post(`/stamp/generate-invoice/${razonSocial}`, data);
  return response.data;
}